import { DEFAULT_LOCALE, LOCALES } from "../shared/constants/locales";

export function resolveLocale(defaultLocale: string = DEFAULT_LOCALE) {
    const { language } = window.navigator;
    const browserLocale = (language || defaultLocale).split("-")[0];

    return LOCALES.includes(browserLocale) ? browserLocale : defaultLocale;
}
